import React from "react";
import styles from "./styles.module.scss";
import useDomainStore from "../../../stores/domain";

const FancyRadioInput = ({ id, name, label, value, ...props }) => {
  const { isKurvDomain } = useDomainStore();
  return (
    <div
      className={`${styles.radioButton} ${props.className || ""} ${isKurvDomain ? styles.kurv_theme : ""}`}
    >
      <input id={id} type="radio" name={name} value={value} {...props} />
      <label htmlFor={id}></label>
      <span>{label}</span>
    </div>
  );
};

export default FancyRadioInput;
